import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_616_1226)">
      <path
        d="M13.4279 0H2.54848C1.86965 0.00655275 1.22091 0.281051 0.743572 0.763702C0.266233 1.24635 -0.00102845 1.89805 2.97432e-06 2.57684V13.4375C0.000337212 14.1167 0.270221 14.768 0.750402 15.2485C1.23058 15.7289 1.88181 15.9992 2.56111 16H13.4389C14.1178 15.997 14.768 15.7258 15.2477 15.2454C15.7275 14.7651 15.9979 14.1146 16 13.4358V2.57684C15.9959 1.89555 15.7238 1.24325 15.2425 0.761021C14.7611 0.278794 14.1093 0.00540993 13.4279 0ZM7.98821 12.1983C7.42103 12.1992 6.85636 12.123 6.30972 11.9718C6.15319 12.0001 6.00054 12.0467 5.85493 12.1107L4.82072 12.7549C4.51753 12.9562 4.41731 12.8813 4.53016 12.528L4.75671 11.7204C4.76917 11.5594 4.75653 11.3975 4.71924 11.2404C4.11161 10.8608 3.60712 10.337 3.25055 9.71563C2.89397 9.09423 2.69636 8.39442 2.67523 7.67832C2.67523 5.19074 5.0599 3.15789 7.98821 3.15789C8.8047 3.14364 9.61457 3.30667 10.3619 3.63575C11.1093 3.96483 11.7764 4.45212 12.3171 5.064L7.3692 7.41263C7.2205 7.5284 7.03465 7.5859 6.84655 7.57435C6.65845 7.5628 6.48103 7.48298 6.34762 7.34989L5.55174 6.64253C5.18623 6.528 5.0599 6.65516 5.17402 6.98274L6.0318 9.06695C6.22129 9.38274 6.51185 9.48421 6.99147 9.12968L12.7327 5.63074C13.101 6.24525 13.2969 6.94761 13.2999 7.664C13.3012 10.1655 10.9153 12.1983 7.98821 12.1983Z"
        fill="#00C950"
      />
    </g>
    <defs>
      <clipPath id="clip0_616_1226">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
